export default __webpack_public_path__ + "static/media/Linode.d6dc72f0.svg";